import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { DateHelper } from 'src/app/helpers/date-helper';
import { ColumnDefinition } from 'src/app/models/server/column-definition';
import { Folder } from 'src/app/models/server/folder';
import { WorkflowStepPropertyCodes } from '../constantes/workflow-step-property-codes';

@Pipe({
    name: 'avmFolderWorkflowCellPipe',
    standalone: true,
    pure: true,
})
export class AvmFolderWorkflowCellPipe implements PipeTransform {
    constructor(
        protected datePipe: DatePipe,
        protected dateHelper: DateHelper
    ) {}

    /**
     * Formate une cellule de la liste des dossiers.
     * @param folder : Instance du dossier affiché par la ligne contenant la cellule.
     * @param columnDefinition : Définition de la colonne affichant la cellule
     */
    transform(folder: Folder, columnDefinition: ColumnDefinition, property: string): string {
        //console.count(`AvmFolderWorkflowCellPipe - transform ${folder.id} - ${columnDefinition.header}`);

        const workflowStepsSnapshot = folder.workflowStepsSnapshot?.find((x) => x.workflowStepId.toString() == columnDefinition.propertyCode);

        if (workflowStepsSnapshot) {
            if (property === WorkflowStepPropertyCodes.STATE) {
                return !!workflowStepsSnapshot ? workflowStepsSnapshot.currentStateName.toString() : '-';
            } else if (property === WorkflowStepPropertyCodes.DATE) {
                return !!workflowStepsSnapshot ? this.dateHelper.formatAsFrenchDate(workflowStepsSnapshot.currentStateDate) : '';
            } else if (property === WorkflowStepPropertyCodes.COMPLETED) {
                return !!workflowStepsSnapshot
                    ? workflowStepsSnapshot.completed
                        ? 'step-completed'
                        : workflowStepsSnapshot.inProgress
                          ? 'step-in-progress'
                          : 'step-not-started'
                    : 'step-not-activated';
            }
        }

        return '';
    }
}
